module.exports = __webpack_public_path__ + "img/icon-Its-franchisees.8d6df662.png";